import { Container, Row, Col, Card, CardHeader, CardBody } from "reactstrap";
import SimpleHeader from "../../components/SimpleHeader/SimpleHeader";

const SupportHelpPage = () => {
  return (
    <>
      <SimpleHeader name="Home" parentName="Support / Help" />
      <Container className="mt--6 fluid">
        <Row className="justify-content-center">
          <Col className="card-wrapper">
            <Card>
              <CardHeader>
                <h2 className="m-4">Coming Soon!</h2>
              </CardHeader>
              <CardBody>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                  Laboriosam corrupti alias perspiciatis, quibusdam consectetur
                  reiciendis dolores molestiae est deleniti! Aliquam ipsam culpa
                  enim pariatur voluptatum sit dolorum dolores, commodi
                  delectus!
                </p>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default SupportHelpPage;
